import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from './components/login/login.component';
import { AuthService } from './services/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(private AUTH: AuthService, private DIALOG: MatDialog) {}

  title = 'nhf-cares';

  adminLoggedIn = true;

  ngOnInit() {
    this.AUTH.$user.subscribe((user) => {
      user ? (this.adminLoggedIn = true) : (this.adminLoggedIn = false);
    });
  }

  login() {
    this.DIALOG.open(LoginComponent);
  }

  logout() {
    this.AUTH.signOut();
  }
}
